import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  loadTrailerGroups,
  loadTrailerGroupsFailure,
  loadTrailerGroupsSuccess,
} from '@store/trailers/trailerGroups.actions';
import {
  loadTrailers,
  loadTrailersFailure,
  loadTrailersSuccess,
} from '@store/trailers/trailers.actions';

import { ApiTrailersService } from '../../app/portal/pages/trailers/api-trailers.service';

@Injectable()
export class TrailersEffects {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(ApiTrailersService);

  loadTrailers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTrailers),
      mergeMap(() =>
        this.apiService.trailersList().pipe(
          map((trailers) => loadTrailersSuccess({ list: trailers })),
          catchError((error) => of(loadTrailersFailure({ error: error.message }))),
        ),
      ),
    ),
  );

  loadTrailerGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTrailerGroups),
      mergeMap(() =>
        this.apiService.trailerGroupsList().pipe(
          map((groups) => loadTrailerGroupsSuccess({ list: groups })),
          catchError((error) => of(loadTrailerGroupsFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
